/**
 * Experience data
 */

export const experienceData = [
  {
    id: 1,
    image: require('../images/company/citi.jpg'),
    imageAlt: 'Citi logo',
    title: 'Software Engineer',
    subtitle: 'Citi Bank',
    date: 'Current Job',
    items: [
      'Full Stack Dev working with Java and Angular',
      'Representative for the 1st and 2nd year grad rotation Technology analyst cohort',
    ],
  },
  {
    id: 2,
    image: require('../images/company/citi.jpg'),
    imageAlt: 'Citi logo',
    title: 'Enterprise Operations and Technology Summer Analyst',
    subtitle: 'Citi Bank',
    date: 'June 2023 - August 2023',
    items: [
      'Neuda Net Migration Project (see projects)',
      'Wireframe Design for correcting balances new screen (see projects)',
    ],
  },
  {
    id: 3,
    image: require('../images/company/imperial_logo.jpg'),
    imageAlt: 'Imperial College London logo',
    title: 'Undergraduate Teaching Assistant',
    subtitle: 'Imperial College London',
    date: 'Oct 2022 - Present',
    description: 'Explain concepts and work through problem sheets with students in the 2nd year EIE course.',
  },
  {
    id: 4,
    image: require('../images/company/barclays_logo.jpg'),
    imageAlt: 'Barclays logo',
    title: 'Bank Teller',
    subtitle: 'Barclays',
    date: 'Aug 2018 - Feb 2019',
    description: 'Assisted customers with transactions and helped behind the desk by managing deposited and withdrawn money. Interacted in multiple languages, provided clarification about transactions and bills.',
  },
];

